module.exports = __webpack_public_path__ + "img/del_fil.9905477f.svg";